module.exports = __webpack_public_path__ + "img/C08TechBladeChariotChampion_ua.2b7fe8bd.webp";